// import React, { useState } from 'react';
// import { Home, Zap, ShoppingCart, User, Settings, ChevronRight, ChevronLeft, Trash2 } from 'lucide-react';

// const initialItems = [
//     { id: 1, name: "AE Dunamis 10KVA Relay Stabilizer (45V-270V)", price: 25000, quantity: 1, imageUrl: "https://placehold.co/80x80/e5e5e5/333333?text=Item1" },
//     { id: 2, name: "AE Dunamis 10KVA Relay Stabilizer (45V-270V)", price: 25000, quantity: 1, imageUrl: "https://placehold.co/80x80/e5e5e5/333333?text=Item2" },
//     { id: 3, name: "AE Dunamis 10KVA Relay Stabilizer (45V-270V)", price: 25000, quantity: 1, imageUrl: "https://placehold.co/80x80/e5e5e5/333333?text=Item3" },
// ];

// /**
//  * Order Item Row with Swipe-to-Delete functionality
//  */

// const formatCurrency = (amount) => `₦${amount.toLocaleString('en-US', { minimumFractionDigits: 2 })}`;

// const OrderItem = ({ item, onQuantityChange, onDelete }) => {
//     const [isSwiped, setIsSwiped] = useState(false);
//     const [dragStartX, setDragStartX] = useState(0);
//     const [isDragging, setIsDragging] = useState(false);
//     const revealWidth = 80; 

//     // Touch and Mouse handlers combined for swipe detection
//     const handleStart = (clientX) => {
//         setDragStartX(clientX);
//         setIsDragging(true);
//         setIsSwiped(false);
//     };

//     const handleMove = (clientX) => {
//         if (!isDragging && window.PointerEvent && !window.TouchEvent) return; // Only process move if dragging started
        
//         const deltaX = clientX - dragStartX;
        
//         if (deltaX < 0) {
//             // Swipe Left (Reveal delete)
//             if (Math.abs(deltaX) > 50) { 
//                 setIsSwiped(true);
//             }
//         } else if (deltaX > 50) {
//             // Swipe Right (Hide delete)
//             setIsSwiped(false);
//         }
//     };

//     const handleEnd = () => {
//         setIsDragging(false);
//     };

//     return (
//         <div 
//             className="relative w-full overflow-hidden mb-4"
//             // Mouse Handlers
//             onMouseDown={(e) => handleStart(e.clientX)}
//             onMouseMove={(e) => handleMove(e.clientX)}
//             onMouseUp={handleEnd}
//             onMouseLeave={handleEnd} 
//             // Touch Handlers
//             onTouchStart={(e) => handleStart(e.touches[0].clientX)}
//             onTouchMove={(e) => handleMove(e.touches[0].clientX)}
//             onTouchEnd={handleEnd}
//         >
//             {/* Delete Button (Visible when content is swiped) */}
//             <div 
//                 className={`absolute inset-y-0 right-0 w-[${revealWidth}px] flex items-center justify-center transition-opacity duration-300 rounded-xl`}
//                 style={{ backgroundColor: '#F94144' }}
//                 onClick={() => onDelete(item.id)}
//             >
//                 <Trash2 className="w-6 h-6 text-white" />
//             </div>

//             {/* Swipeable Content */}
//             <div
//                 className={`flex items-center bg-white rounded-xl shadow-sm p-3 transition-transform duration-300`}
//                 style={{ 
//                     transform: isSwiped ? `translateX(-${revealWidth}px)` : 'translateX(0)',
//                     position: 'relative',
//                     zIndex: 10
//                 }}
//             >
//                 <img 
//                     src={item.imageUrl}
//                     alt={item.name}
//                     className="w-20 h-20 rounded-lg object-cover bg-gray-100 mr-4"
//                     onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/80x80/e5e5e5/333333?text=N/A"; }}
//                 />
                
//                 <div className="flex-1 min-w-0">
//                     <p className="text-sm font-medium text-gray-800 line-clamp-2">{item.name}</p>
//                     <p className="text-sm font-semibold text-blue-600 mt-1">
//                         - {formatCurrency(item.price)}
//                     </p>
//                 </div>
                
//                 {/* Quantity Controls */}
//                 <div className="flex flex-col items-center ml-4 text-gray-700 font-medium">
//                     <button 
//                         className="text-gray-500 hover:text-blue-500 transition" 
//                         onClick={(e) => { e.stopPropagation(); onQuantityChange(item.id, item.quantity + 1); }}
//                     >
//                         +
//                     </button>
//                     <span className="text-lg font-bold mx-2">{item.quantity}</span>
//                     <button 
//                         className="text-gray-500 hover:text-blue-500 transition" 
//                         onClick={(e) => { e.stopPropagation(); item.quantity > 1 ? onQuantityChange(item.id, item.quantity - 1) : onDelete(item.id); }}
//                     >
//                         -
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// };

// // Helper component for summary rows
// const SummaryRow = ({ label, value, isNegative = false, isFree = false }) => (
//     <div className="flex justify-between text-gray-600">
//         <span>{label}</span>
//         <span className={isNegative ? 'text-red-500' : (isFree ? 'text-green-500' : 'text-gray-800')}>{value}</span>
//     </div>
// );


// /**
//  * Order Screen
//  */
// const OrderScreen = ({ onBack }) => {
//     const [items, setItems] = useState(initialItems);

//     const itemDiscount = 28.80; 
//     const couponDiscount = 15.80;
    
//     const handleQuantityChange = (id, newQuantity) => {
//         setItems(items.map(item => 
//             item.id === id ? { ...item, quantity: newQuantity } : item
//         ));
//     };

//     const handleDelete = (id) => {
//         setItems(items.filter(item => item.id !== id));
//     };

//     // Calculate totals (mock data for simplicity)
//     const subtotal = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
//     const total = subtotal - itemDiscount - couponDiscount;

//     return (
//         <div className="w-full max-w-md bg-gray-100 shadow-xl overflow-hidden flex flex-col h-full absolute top-0 left-0">
            
//             {/* Header */}
//             <header className="flex items-center justify-between p-4 bg-white border-b border-gray-100 shadow-sm z-20">
//                 <button onClick={onBack} className="text-gray-800 p-1 rounded-full hover:bg-gray-100 transition">
//                     <ChevronLeft className="w-6 h-6" />
//                 </button>
//                 <h1 className="text-lg font-bold text-gray-800 flex-1 text-center pr-8">My order</h1>
//                 <div className="w-6"></div> 
//             </header>

//             {/* Content */}
//             <main className="flex-1 overflow-y-auto p-4 pb-28">
                
//                 {/* Order Item List */}
//                 <div className="mb-8">
//                     {items.map(item => (
//                         <OrderItem 
//                             key={item.id} 
//                             item={item} 
//                             onQuantityChange={handleQuantityChange}
//                             onDelete={handleDelete}
//                         />
//                     ))}
//                     {items.length === 0 && (
//                         <div className="text-center text-gray-500 pt-10">
//                             Your order list is empty.
//                         </div>
//                     )}
//                 </div>
                
//                 {/* Payment Summary */}
//                 <section className="mt-8 bg-white p-4 rounded-xl shadow-sm">
//                     <h2 className="text-lg font-bold text-gray-800 mb-4">Payment Summary</h2>
                    
//                     <div className="space-y-3 text-sm">
//                         <SummaryRow label="Order Total" value={formatCurrency(subtotal)} />
//                         <SummaryRow label="Items Discount" value={`- ${formatCurrency(itemDiscount)}`} isNegative={true} />
//                         <SummaryRow label="Coupon Discount" value={`- ${formatCurrency(couponDiscount)}`} isNegative={true} />
//                         <SummaryRow label="Shipping" value="Free" isFree={true} />
                        
//                         <div className="flex justify-between font-bold text-base pt-3 border-t border-gray-200">
//                             <span>Total</span>
//                             <span className="text-gray-800">{formatCurrency(total)}</span> 
//                         </div>
//                     </div>
//                 </section>

//             </main>

//             {/* Fixed Bottom Action Bar */}
//             <div className="fixed bottom-0 w-full max-w-md p-4 bg-white border-t border-gray-100 shadow-xl flex justify-between items-center z-30">
//                 <div className="text-lg font-bold text-blue-600">
//                     {formatCurrency(total)} 
//                     <p className="text-xs font-medium text-gray-500">Total price</p>
//                 </div>
//                 <button 
//                     className={`bg-blue-600 text-white font-semibold py-3 px-8 rounded-xl shadow-lg transition duration-150 ${items.length === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-700'}`}
//                     disabled={items.length === 0}
//                 >
//                     Pay Now
//                 </button>
//             </div>
//         </div>
//     );
// };


// export default OrderScreen





import React, { useState, useEffect, useMemo } from 'react';
import { ChevronLeft, Trash2, Loader2 } from 'lucide-react'; 
import { API_BASE_URL } from '../../config/api';

// API Configuration
const ORDERS_API_URL = `${API_BASE_URL}/orders`;

// Helper function to format currency (Assuming NGN)
const formatCurrency = (amount) => `₦${Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2 })}`;

// --- OrderItem component adapted to show read-only ORDER details ---
const OrderItem = ({ item }) => {
    // API Data mapping for an individual order object
    const orderId = item.id;
    const orderStatus = item.status?.label || 'N/A';
    const product = item.product;
    
    // Calculate total price for this specific order
    const totalOrderAmount = (item.amount || 0) * (item.quantity || 1); 
    
    const imageUrl = product?.images?.[0]?.url || "https://placehold.co/80x80/e5e5e5/333333?text=N/A";
    const name = product?.name || 'Product Not Found';
    const quantity = item.quantity || 1;

    // NOTE: Swipe-to-Delete and Quantity Controls are visually kept 
    // but made static/non-functional for this read-only screen.

    const [isSwiped, setIsSwiped] = useState(false);
    const revealWidth = 80; 

    // Placeholder handlers to satisfy the original component's structure
    const handleStart = () => {};
    const handleMove = () => {};
    const handleEnd = () => {};

    return (
        <div 
            className="relative w-full overflow-hidden mb-4"
            // Handlers are kept but do nothing
            onMouseDown={handleStart}
            onMouseMove={handleMove}
            onMouseUp={handleEnd}
            onTouchStart={handleStart}
            onTouchMove={handleMove}
            onTouchEnd={handleEnd}
        >
            {/* Delete Button (Visually present, functionally disabled) */}
            <div 
                className={`absolute inset-y-0 right-0 w-[${revealWidth}px] flex items-center justify-center transition-opacity duration-300 rounded-xl bg-gray-400`}
                style={{ right: isSwiped ? 0 : `-${revealWidth}px` }} 
            >
                <Trash2 className="w-6 h-6 text-white" />
            </div>

            {/* Content Displaying Order Details */}
            <div
                className={`flex items-center bg-white rounded-xl shadow-sm p-3 transition-transform duration-300`}
                style={{ 
                    transform: isSwiped ? `translateX(-${revealWidth}px)` : 'translateX(0)',
                    position: 'relative',
                    zIndex: 10
                }}
            >
                <img 
                    src={imageUrl}
                    alt={name}
                    className="w-20 h-20 rounded-lg object-cover bg-gray-100 mr-4"
                    onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/80x80/e5e5e5/333333?text=N/A"; }}
                />
                
                <div className="flex-1 min-w-0">
                    {/* Display Product Name and Order ID/Status */}
                    <p className="text-sm font-medium text-gray-800 line-clamp-2">{name} (Order ID: {orderId.substring(0, 8)}...)</p>
                    <p className="text-sm font-semibold text-blue-600 mt-1">
                        Total: {formatCurrency(totalOrderAmount)}
                    </p>
                    <p className="text-xs text-gray-500 mt-1">Status: **{orderStatus}** | Qty: {quantity}</p>
                </div>
                
                {/* Quantity Controls (Static/Disabled) */}
                <div className="flex flex-col items-center ml-4 text-gray-700 font-medium">
                    <button className="text-gray-300 transition" disabled={true}>+</button>
                    <span className="text-lg font-bold mx-2">1</span> {/* Always 1 instance of the order itself */}
                    <button className="text-gray-300 transition" disabled={true}>-</button>
                </div>
            </div>
        </div>
    );
};

// Helper component for summary rows (Kept for structural integrity)
const SummaryRow = ({ label, value, isNegative = false, isFree = false }) => (
    <div className="flex justify-between text-gray-600">
        <span>{label}</span>
        <span className={isNegative ? 'text-red-500' : (isFree ? 'text-green-500' : 'text-gray-800')}>{value}</span>
    </div>
);


/**
 * Order Screen (Adapted to List Orders)
 */
const OrderScreen = ({ onBack, authToken }) => {
    // Removed initialItems
    const [orders, setOrders] = useState([]); // Now stores the list of orders
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    // Mock discounts (Kept for structural integrity of the Summary section)
    const itemDiscount = 0; 
    const couponDiscount = 0;
    
    // Placeholder handlers to keep the component structure clean
    const handleQuantityChange = () => {}; 
    const handleDelete = () => {}; 

    // 1. Fetch data on component mount
    useEffect(() => {
        const fetchOrders = async () => {
            setIsLoading(true);
            setError(null);

            if (!authToken) {
                setError("Authentication token is missing.");
                setIsLoading(false);
                return;
            }

            try {
                const response = await fetch(ORDERS_API_URL, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authToken}`,
                    },
                });

                const result = await response.json();

                if (response.ok && result.status === "SUCCESS") {
                    // Use the 'orders' array from the API response
                    setOrders(result.data.orders || []); 
                } else {
                    throw new Error(result.message || `Failed to fetch orders: ${response.status}`);
                }

            } catch (err) {
                console.error('API Error:', err);
                setError(err.message || 'A network error occurred while fetching your orders.');
            } finally {
                setIsLoading(false);
            }
        };

        fetchOrders();
    }, [authToken]);

    // Calculate total of ALL orders (used for the bottom bar, though typically not shown in a list view)
    const overallTotal = useMemo(() => {
        return orders.reduce((sum, order) => sum + (order.amount || 0) * (order.quantity || 1), 0);
    }, [orders]);
    
    // Mock summary data for display (based on first order or zero)
    const subtotalDisplay = orders.length > 0 ? (orders[0].amount * orders[0].quantity) : 0;
    const totalDisplay = overallTotal; // Use overall total for the footer

    // 3. Render content based on state
    let orderListContent;
    if (isLoading) {
        orderListContent = (
            <div className="flex flex-col items-center justify-center h-full pt-10">
                <Loader2 className="w-8 h-8 text-blue-500 animate-spin mb-4" />
                <p className="text-gray-600">Loading your orders...</p>
            </div>
        );
    } else if (error) {
        orderListContent = (
            <div className="text-center text-red-500 pt-10">
                <p className="font-semibold mb-2">Error: {error}</p>
                <p className="text-sm text-gray-500">Could not retrieve order list.</p>
            </div>
        );
    } else {
        orderListContent = (
            <>
                {orders.map(order => (
                    // Pass the whole order object as 'item' to OrderItem for display
                    <OrderItem 
                        key={order.id} 
                        item={order} 
                        // Handlers are kept for structural integrity but are non-functional
                        onQuantityChange={handleQuantityChange}
                        onDelete={handleDelete}
                    />
                ))}
                {orders.length === 0 && (
                    <div className="text-center text-gray-500 pt-10">
                        Your order list is empty.
                    </div>
                )}
            </>
        );
    }

    // --- Main Component Render (The original UI structure) ---
    return (
        <div className="w-full max-w-md bg-gray-100 shadow-xl overflow-hidden flex flex-col h-full absolute top-0 left-0">
            
            {/* Header */}
            <header className="flex items-center justify-between p-4 bg-white border-b border-gray-100 shadow-sm z-20">
                <button onClick={onBack} className="text-gray-800 p-1 rounded-full hover:bg-gray-100 transition">
                    <ChevronLeft className="w-6 h-6" />
                </button>
                <h1 className="text-lg font-bold text-gray-800 flex-1 text-center pr-8">My Orders</h1>
                <div className="w-6"></div> 
            </header>

            {/* Content */}
            <main className="flex-1 overflow-y-auto p-4 pb-28">
                
                {/* Order Item List (displays the fetched orders) */}
                <div className="mb-8">
                    {orderListContent}
                </div>
                
                {/* Payment Summary (Kept for structural compliance, data is minimal/mocked) */}
                <section className="mt-8 bg-white p-4 rounded-xl shadow-sm">
                    <h2 className="text-lg font-bold text-gray-800 mb-4">Summary (First Order)</h2>
                    
                    <div className="space-y-3 text-sm">
                        <SummaryRow label="Order Subtotal" value={formatCurrency(subtotalDisplay)} />
                        <SummaryRow label="Items Discount" value={`- ${formatCurrency(itemDiscount)}`} isNegative={itemDiscount > 0} />
                        <SummaryRow label="Coupon Discount" value={`- ${formatCurrency(couponDiscount)}`} isNegative={couponDiscount > 0} />
                        <SummaryRow label="Shipping" value="Free" isFree={true} />
                        
                        <div className="flex justify-between font-bold text-base pt-3 border-t border-gray-200">
                            <span>Total</span>
                            <span className="text-gray-800">{formatCurrency(subtotalDisplay - itemDiscount - couponDiscount)}</span> 
                        </div>
                    </div>
                </section>

            </main>

            {/* Fixed Bottom Action Bar */}
            <div className="fixed bottom-0 w-full max-w-md p-4 bg-white border-t border-gray-100 shadow-xl flex justify-between items-center z-30">
                <div className="text-lg font-bold text-blue-600">
                    {formatCurrency(totalDisplay)} 
                    <p className="text-xs font-medium text-gray-500">Total Price of All Orders</p>
                </div>
                <button 
                    // This button should probably link to a detail page, but remains "Pay Now" visually.
                    className={`bg-blue-600 text-white font-semibold py-3 px-8 rounded-xl shadow-lg transition duration-150 ${orders.length === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-700'}`}
                    disabled={orders.length === 0}
                >
                    View Details
                </button>
            </div>
        </div>
    );
};


export default OrderScreen;
